import React from 'react';

type Plan = 'SILVER' | 'GOLD' | 'PLATINUM';

interface PlanBadgeProps {
  plan: Plan;
  size?: 'sm' | 'md' | 'lg';
  showPrice?: boolean;
  className?: string;
}

const PLAN_COLORS: Record<Plan, { bg: string; text: string }> = {
  SILVER: { bg: 'bg-slate-500', text: 'text-white' },
  GOLD: { bg: 'bg-amber-500', text: 'text-white' },
  PLATINUM: { bg: 'bg-violet-500', text: 'text-white' },
};

const PLAN_PRICES: Record<Plan, number> = {
  SILVER: 1000,
  GOLD: 2000,
  PLATINUM: 3000,
};

export const PlanBadge: React.FC<PlanBadgeProps> = ({
  plan,
  size = 'md',
  showPrice = false,
  className = '',
}) => {
  const colors = PLAN_COLORS[plan];
  const price = PLAN_PRICES[plan];
  
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5',
  };
  
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <span
        className={`${colors.bg} ${colors.text} font-semibold rounded-full ${sizeClasses[size]} shadow-sm`}
        title={`${plan} Plan`}
      >
        {plan}
      </span>
      {showPrice && (
        <span className="text-gray-600 text-sm">
          ₹{price.toLocaleString('en-IN')}/mo
        </span>
      )}
    </div>
  );
};

